import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services/loader-services/loader.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {
  loading = false;
  progress = null;

  constructor(private loader: LoaderService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.loader.getLoading().subscribe((isLoading) => {
      this.loading = isLoading;
      this.cdr.detectChanges();  // 🛠 Ensure Angular detects changes
    });
    this.loader.getProgress().subscribe((progress) => {
      this.progress = progress !== null ? Math.max(progress, 5): progress; //optimistic
      this.cdr.detectChanges();  // 🛠 Ensure Angular detects changes
    });
  }

}
